require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-expands-to-hancock-county-with-mccordsville-branch.json") })
        }
      }, "path---articles-financial-center-expands-to-hancock-county-with-mccordsville-branch");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-expands-to-hancock-county-with-mccordsville-branch!./.cache/json/articles-financial-center-expands-to-hancock-county-with-mccordsville-branch.json
// module id = 1612
// module chunks = 231608221292675